export default "__VITE_PUBLIC_ASSET__fde3e38d__"